import { useDisclosure, UseDisclosureReturn } from '@chakra-ui/react'
import React, { useState } from 'react'
import { ListSavedSearchSuccessResponse } from '../interfaces'
import { ListBookmarkSuccessResponse } from '../interfaces/BookmarksResponse'

interface NavBarProviderProps {
  children: React.ReactNode
}

interface NavBarContextType
  extends Pick<
    UseDisclosureReturn,
    'isOpen' | 'onOpen' | 'onClose' | 'onToggle'
  > {
  savedSearches: ListSavedSearchSuccessResponse[]
  setSavedSearches: React.Dispatch<
    React.SetStateAction<ListSavedSearchSuccessResponse[]>
  >
  bookmarks: ListBookmarkSuccessResponse
  setBookmarks: React.Dispatch<
    React.SetStateAction<ListBookmarkSuccessResponse>
  >
}

export const NavBarContext = React.createContext<NavBarContextType>({
  isOpen: true,
  onOpen: () => {},
  onToggle: () => {},
  onClose: () => {},
  savedSearches: [],
  setSavedSearches: () => {},
  bookmarks: [],
  setBookmarks: () => {},
})

export const NavBarProvider: React.FC<NavBarProviderProps> = ({
  children,
}: NavBarProviderProps) => {
  const { isOpen, onToggle, onOpen, onClose } = useDisclosure({
    defaultIsOpen: true,
  })
  const [savedSearches, setSavedSearches] =
    useState<ListSavedSearchSuccessResponse[]>([])
  const [bookmarks, setBookmarks] = useState<ListBookmarkSuccessResponse>([])

  return (
    <NavBarContext.Provider
      value={{
        isOpen,
        onToggle,
        onOpen,
        onClose,
        savedSearches,
        setSavedSearches,
        bookmarks,
        setBookmarks,
      }}
    >
      {children}
    </NavBarContext.Provider>
  )
}
